import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { CarBackgroundLarge } from './CarBackgroundLarge.js';
import styles from './CarBackground.module.scss.js';
import { CarBackgroundSmall } from './CarBackgroundSmall.js';

var CarBackground = function () { return (jsxs(Fragment, { children: [jsx(CarBackgroundLarge, { className: styles.iconLarge }), jsx(CarBackgroundSmall, { className: styles.iconSmall })] })); };

export { CarBackground };
